import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/close.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-009e98e6")

_pushScopeId("data-v-009e98e6")
const _hoisted_1 = { class: "genericPadding hasHeader" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "successMessage"
}
const _hoisted_7 = { class: "twoBlocksContainer justify-content-around" }
const _hoisted_8 = { class: "profileImage" }
const _hoisted_9 = { class: "fs_13 greyBlue d-block mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "__modalsContainer __show"
}
const _hoisted_11 = { class: "__modalBg" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "fs-14 greyBlue" }
const _hoisted_15 = { class: "mt-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "sideContainer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_3
        ]),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _hoisted_5
      ]),
      (_ctx.successMessage)
        ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.successMessage), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.people, (item, ii) => {
          return (_openBlock(), _createBlock("div", {
            class: "text-center w-50 mb-4",
            key: ii,
            onClick: ($event: any) => (_ctx.openPerson(item))
          }, [
            _withDirectives(_createVNode("div", _hoisted_8, null, 512), [
              [_directive_userimage, _ctx.$store.state.getUserImage(item.identifier)]
            ]),
            _createVNode("span", _hoisted_9, _toDisplayString(item.name), 1)
          ], 8, ["onClick"]))
        }), 128))
      ])
    ]),
    (_ctx.showOptionsModal)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", {
              class: "bottomModalContainer",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOptionsModal = false))
            }, [
              _createVNode("div", {
                class: "bottomModal",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent","stop"]))
              }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.selectedPerson.name), 1)
                  ]),
                  _createVNode("img", {
                    src: _imports_1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOptionsModal = false))
                  })
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", {
                    class: "genericButton bgGreyBlue",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPersonProfile(_ctx.selectedPerson.identifier)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_vaiAlProfilo",
                      text: "Vai al profilo",
                      class: "fs_13 white text-uppercase"
                    })
                  ]),
                  _createVNode("div", {
                    class: "genericButton bgWhite squareGenericButton mt-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteUser(_ctx.selectedPerson)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_bloccaUtente",
                      text: "Blocca Utente",
                      class: "fs_13 spaceCadet text-uppercase"
                    })
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})